import api from '@/api/index'

export default {
  get: async () => {
    const response = await api.system.get()
    const { data } = response
    return data
  },
}
